export default {
  "qr-code": "_qr-code_1248am"
};